import { Core, strings } from "Components/core";

function extractFileNameFromPath(path) {
  return path.split("\\").pop(); // we need this only in windows
}

export class Attach extends Core {
  constructor(domElem) {
    super(domElem, Attach.className);
    this._control = _this.getElemNode("control");
    this._onClearClickCtx = this._onClearClick.bind(this);
    domElem.addEventListener("change", this._onChange.bind(this));
  }

  clear() {
    if (!this.getVal()) return this;
    return this._clear();
  }

  getVal() {
    return this._control.value;
  }

  getName() {
    return this._control.getAttribute("name");
  }

  _onChange(e) {
    e.stopPropagation();
    this.getVal() ? this._updateFileElem()._emit("change") : this._clear();
  }

  _updateFileElem() {
    let file = this.getElemNode("file"),
      elemName = Attach.className + Attach.ELEM_DELIM;
    file && file.remove();
    file = document.createElement("span");
    file.classList.add("".concat(elemName, "file"));
    file.innerHTML = [
      '<span class="'.concat(elemName, 'text">'),
      strings.escape.html(extractFileNameFromPath(this.getVal())),
      "</span>",
      '<span class="'.concat(elemName, 'clear"></span>'),
    ].join("");
    this.domElem.appendChild(file);
    this._clearElem = this.getElemNode("clear").addEventListener(
      "click",
      this._onClearClickCtx
    );
    return this;
  }

  _onClearClick(e) {
    this.clear();
  }

  _clear() {
    const control = document.createElement("input"),
      file = this.getElemNode("file"),
      clearElem = this._clearElem,
      controlParent = this._control.parentNode;

    clearElem && clearElem.removeEventListener("click", this._onClearClickCtx);

    file && file.remove();

    control.setAttribute("type", "file");

    ["name", "class"].forEach((attr) => {
      return control.setAttribute(attr, this._control.getAttribute(attr));
    });

    this._control.removeEventListener("change", this._onChange.bind(this));

    controlParent.replaceChild(control, this._control);
    this._control = control;

    this._control.addEventListener("change", this._onChange.bind(this));

    this._emit("change");

    return this;
  }

  static className = "attach";
  static instances = {};

  static init() {
    document.querySelectorAll(`.${Attach.className}`).forEach((el) => {
      return new Attach(el);
    });
  }
}
